import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

export default mutatorAction('removeCacheUpdateLogMutator', function removeCacheUpdateLogMutator() {
    getStore().cacheUpdateLogs.shift();
});
